/* src/locations/cards/LocationCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Button, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Add, MoreHoriz } from '@material-ui/icons';

import AddLocationCard from '../AddLocationCard';
import { PaperHeader, HeaderTable } from '../../../../app/components';
import styles from './styles';
import { loadTexts } from '../../../../config/texts';

import { fetchLocations, removeLocation } from '../../actions';
import {
  locationNameChanged,
  locationAddressChanged,
  locationCityChanged,
  locationTypeChanged,
  locationLongitudeChanged,
  locationLatitudeChanged,
  clearLocationFields,
} from '../../../locations/cards/AddLocationCard/actions';

import {
  getLocations,
  fetchLocationsState,
  getLocationsListRange,
  getUniversities,
} from '../../selectors';
const TEXT_KEY = "location";

class LocationCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      location: { _id: '' },
      mode: 'add',
      open: false,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._onFetchLocations = this._onFetchLocations.bind(this);
    this._onNextPage = this._onNextPage.bind(this);
    this._onPrevPage = this._onPrevPage.bind(this);
    this._onMoreActions = this._onMoreActions.bind(this);
    this._onCloseLocation = this._onCloseLocation.bind(this);
    this._onAddLocation = this._onAddLocation.bind(this);
    this._onRemoveLocation = this._onRemoveLocation.bind(this);
    this._onOpenEditLocation = this._onOpenEditLocation.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onOpenAdd = this._onOpenAdd.bind(this);
  }

  componentDidMount() {
    const { listRange: { start, end }, locations } = this.props;
    this._onFetchLocations(start, end);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedUniversity !== this.props.selectedUniversity
      || nextProps.selectedOrganization !== this.props.selectedOrganization
    ) {
      this.props.fetchLocations({ input: {
        universities: [nextProps.selectedUniversity],
        radius: 50000,
        types: ['CAFE', 'UNIVERSITY'],
      } });
    }
  }

  _onFetchLocations() {
    this.props.fetchLocations({ input: {
      universities: [this.props.selectedUniversity],
      radius: 50000,
      types: ['CAFE', 'UNIVERSITY'],
    } });
  }

  _onNextPage() {
    const { listRange: { end } } = this.props;
    this._onFetchLocations(end, end + 10);
  }

  _onPrevPage() {
    const { listRange: { start } } = this.props;
    this._onFetchLocations(start - 10, start);
  }

  _onMoreActions(location) {
    return event => { this.setState({ anchorEl: event.currentTarget, location }); };
  }

  _onCloseLocation() {
    this.setState({ open: false, anchorEl: null }, () => this.props.clearLocationFields());
  }

  _onAddLocation() {
    this._onFetchLocations();
    this.setState(
      { open: false, anchorEl: null, location: { _id: '' } },
      () => this.props.clearLocationFields()
    );
  }

  _onRemoveLocation() {
    this.props.removeLocation({ location: this.state.location._id })
      .then(() => {
        this.setState({ anchorEl: null });
        this._onFetchLocations();
      });
  }

  _onOpenEditLocation() {
    const { location: { _id } } = this.state;
    const { locationsData } = this.props;
    this.setState({ open: true, mode: 'edit' });
    const { name, address, city, coordinates: { longitude, latitude } } = locationsData[_id];
    this.props.locationTypeChanged('interview');
    this.props.locationNameChanged(name);
    this.props.locationAddressChanged(address);
    this.props.locationCityChanged(city);
    this.props.locationLongitudeChanged(longitude);
    this.props.locationLatitudeChanged(latitude);
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _onOpenAdd() {
    this.setState({ open: true, mode: 'add' });
    // this.props.locationTypeChanged('interview');
  }

  render() {
    const {
      classes,
      onOpen,
      locations,
      listRange: { start, end, count },
      fetchState: { loading },
    } = this.props;
    const { anchorEl, location, open, mode, texts } = this.state;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text={texts.header}>
          <Button color="primary" variant="fab" mini onClick={this._onOpenAdd}>
            <Add />
          </Button>
        </PaperHeader>
        <HeaderTable
          label="locations"
          data={locations}
          Action={datum => (
            <IconButton onClick={this._onMoreActions(datum)}>
              <MoreHoriz />
            </IconButton>
          )}
          loading={loading}
        />
        <AddLocationCard
          ref={node => this._addLocationCard = node}
          location={location._id || ''}
          open={open}
          onClose={this._onCloseLocation}
          onSubmit={this._onAddLocation}
          removedCategories={['interview', 'online_interview']}
          mode={mode}
        />
        <Menu
          id="location-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <MenuItem onClick={this._onOpenEditLocation}>{texts.button_text.edit}</MenuItem>
          <MenuItem onClick={this._onRemoveLocation}>{texts.button_text.delete}</MenuItem>
        </Menu>
      </Paper>
    );
  }
}

LocationCard.propTypes = {
  classes: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  fetchState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  listRange: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    count: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  universities: getUniversities(state),
  locations: getLocations(state),
  fetchState: fetchLocationsState(state),
  listRange: getLocationsListRange(state),
  locationsData: state.interviews.locations.data,
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchLocations: input => dispatch(fetchLocations(input)()),
  locationTypeChanged: text => dispatch(locationTypeChanged(text)),
  locationNameChanged: text => dispatch(locationNameChanged(text)),
  locationAddressChanged: text => dispatch(locationAddressChanged(text)),
  locationCityChanged: text => dispatch(locationCityChanged(text)),
  locationLongitudeChanged: params => dispatch(locationLongitudeChanged(params)),
  locationLatitudeChanged: params => dispatch(locationLatitudeChanged(params)),
  clearLocationFields: () => dispatch(clearLocationFields()),
  removeLocation: params => dispatch(removeLocation(params)()),
});

export default compose(
  withStyles(styles, { name: 'LocationCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(LocationCard);



// WEBPACK FOOTER //
// ./src/modules/locations/cards/LocationCard/index.js